export enum EOccurrenceStatus {
  Approved = 'Approved',
  Disapproved = 'Disapproved',
  Waiting = 'Waiting'
}
